<template>
  <v-app>
    <!-- <app-global-error v-if="globalError"></app-global-error> -->
    <app-alert-dialog
      :model="hasGlobalError"
      :didDismiss="didDismiss"
      :title="globalErrorTitle"
      :message="globalErrorMessage"
    ></app-alert-dialog>
    <div>
      <layout-unauthenticated
        v-if="!isAuthenticated && isFVA"
      ></layout-unauthenticated>
      <layout-authenticated-firstvue-custom
        v-else-if="isFVC"
      ></layout-authenticated-firstvue-custom>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutUnauthenticated from '@/views/layouts/Unauthenticated'
import LayoutAuthenticatedFirstvueCustom from '@/views/layouts/AuthenticatedFirstVueCustom'
// import LayoutAuthenticatedFirstvueCustomLayout from '@/views/layouts/AuthenticatedFirstVueCustomLayout'

export default {
  data: () => ({
    isFVA: false,
    isFVC: false
  }),
  components: {
    LayoutUnauthenticated,
    LayoutAuthenticatedFirstvueCustom
    // LayoutAuthenticatedFirstvueCustomLayout
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('common', [
      'globalErrorTitle',
      'globalErrorMessage',
      'hasGlobalError'
    ])
  },
  created() {
    console.log('App.vue : Created')

    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.setDeviceOrientation
    ) {
      window.webkit.messageHandlers.setDeviceOrientation.postMessage('portrait')
    }

    // If we are running app in browser during development
    // then we manualy simulate calling the startApp
    // const embedded = window.localStorage.getItem('embedded')
    // console.log(`App.vue :: startApp : embedded = ${embedded}`)
    // if (embedded) {
    const that = this
    const token = '7c06645e-86ba-4841-b2bb-c63047ef181c'
    // Store data coming from Unity
    window.localStorage.setItem('platform', 'android')
    window.localStorage.setItem('token', token)
    window.localStorage.setItem('buildVersion', '0.5.10')
    window.localStorage.setItem('env', 'prod')
    window.localStorage.setItem('type', 'fvc')
    window.localStorage.setItem(
      'analyticsToken',
      '8bebf13a-3b9a-44bf-958f-089eeb031e78'
    )
    window.localStorage.setItem('analyticsSessionId', '')
    this.isFVA = false
    this.isFVC = true

    // Get app configs from the server
    setTimeout(() => {
      that.$store.dispatch('app/view', token)
    }, 500)

    window.actions = window.actions || {}
    window.actions.startApp = function(json) {}

    this.$store.dispatch('analytics/startSession')
    // else {
    //   let env = 'prod'
    //   // Default values to FirstVue Agent in prod
    //   let type = 'fva'
    //   let appToken = '20000000-acfa-400a-987d-6b34a71a9f75'
    //   this.isFVA = true
    //   this.isFVC = false

    //   if (!location.origin.includes('firstvue.io')) {
    //     env = 'dev'
    //     type = 'fvc'
    //     this.isFVA = false
    //     this.isFVC = true
    //     // Test Hyecorp custom app
    //     appToken = '7c06645e-86ba-4841-b2bb-c63047ef181c'
    //     window.localStorage.setItem('analyticsToken', '8bebf13a-3b9a-44bf-958f-089eeb031e78')

    //     // Test Hyegrove
    //     // appToken = 'bff67ab4-7ce3-47d6-9968-8a80fe265718'
    //     // window.localStorage.setItem('analyticsToken', null)
    //   }

    // // set env to 'prod' to test on production
    // window.localStorage.setItem('token', appToken)
    // window.localStorage.setItem('env', env)
    // window.localStorage.setItem('type', type)

    // that.$store.dispatch('app/view', appToken)
    // }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        // User has switched tabs, minimized the window, or is navigating away.
        // This is a good place for sending analytics data using navigator.sendBeacon().
        // const data = { message: 'User is no longer viewing the page' }
        // navigator.sendBeacon('/log', JSON.stringify(data))
        this.$store.dispatch('analytics/endSession')
      } else if (document.visibilityState === 'visible') {
        this.$store.dispatch('analytics/startSession')
      }
    })
  },
  methods: {
    didDismiss() {
      this.$store.dispatch('common/clearError')
    }
  }
}
</script>

<style>
.echarts {
  width: 100% !important;
}
</style>
